<template>
  <main
    class="pt-16 bg-white relative flex-1 lg:flex lg:flex-col"
  >
    <!-- Bouton flottant Participer à l'offre - DÉSACTIVÉ
    <transition name="fade-slide">
      <button
        v-if="showFloatingButton"
        @click="scrollToOffres"
        class="floating-cta fixed bottom-4 right-4 sm:bottom-8 sm:right-8 z-50 flex items-center justify-center gap-2 p-3 sm:px-6 sm:py-4 rounded-full text-white font-semibold text-sm sm:text-base shadow-2xl transition-all duration-300 hover:scale-105 hover:shadow-3xl bg-gray-900 hover:bg-gray-800"
      >
        <span class="hidden sm:inline">Participer à l'offre</span>
        <svg class="hidden sm:block w-5 h-5 animate-bounce-subtle" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"/>
        </svg>
      </button>
    </transition>
    -->

    <!-- Section bannière avec image -->
    <div class="w-full flex items-center justify-center" style="background-color: #F4F5F5;">
      <div class="relative w-full" style="max-width: 1240px;">
        <!-- Image de fond -->
        <img
          v-if="bannerImage"
          :src="bannerImage"
          alt="Bannière REDMI Note 15 Series"
          class="h-auto object-contain w-full animate-banner-image"
        />

        <!-- Overlay textes et logos -->
        <div class="absolute inset-0">
          <!-- Logo Xiaomi (top right) -->
          <div class="absolute top-2 right-2 sm:top-3 sm:right-3 md:top-4 md:right-4 animate-logo-mi">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 sm:h-8 md:h-10 lg:h-12 w-auto" viewBox="-200.008 -199.727 512 512">
              <g>
                <path fill="#FF6900" d="M258.626-146.231c-48.304-48.118-117.759-53.496-202.634-53.496c-84.982,0-154.542,5.44-202.826,53.688c-48.277,48.228-53.174,117.676-53.174,202.561c0,84.899,4.897,154.368,53.194,202.613c48.281,48.255,117.833,53.139,202.806,53.139c84.974,0,154.514-4.884,202.795-53.139c48.294-48.254,53.205-117.714,53.205-202.613C311.992-28.472,307.028-97.995,258.626-146.231L258.626-146.231z"/>
                <path fill="#FFFFFF" d="M204.546-41.122c1.759,0,3.223,1.417,3.223,3.161v189.386c0,1.715-1.464,3.139-3.223,3.139H163.05c-1.781,0-3.228-1.424-3.228-3.139V-37.961c0-1.743,1.446-3.161,3.228-3.161H204.546z M24.468-41.122c31.303,0,64.033,1.435,80.176,17.59c16.143,16.154,17.656,47.549,17.656,78.286v96.671c0,1.715-1.446,3.139-3.219,3.139h-41.49c-1.777,0-3.229-1.424-3.229-3.139V53.09c-0.044-17.167-1.031-34.81-9.884-43.692c-7.62-7.641-21.839-9.391-36.625-9.754h-75.21c-1.764,0-3.208,1.419-3.208,3.136v148.645c0,1.715-1.462,3.139-3.237,3.139h-41.516c-1.774,0-3.201-1.424-3.201-3.139V-37.961c0-1.743,1.426-3.161,3.201-3.161H24.468z M33.755,34.305c1.766,0,3.201,1.413,3.201,3.143v113.977c0,1.715-1.436,3.139-3.201,3.139H-9.829c-1.792,0-3.228-1.424-3.228-3.139V37.448c0-1.73,1.436-3.143,3.228-3.143H33.755z"/>
              </g>
            </svg>
          </div>

          <!-- Texte central (positionné à 8% du haut) -->
          <div class="absolute left-0 right-0 text-center flex justify-center px-4" style="top: 4%;">
            <img
              v-if="bigTitleImage"
              :src="bigTitleImage"
              alt="Xiaomi présente REDMI Note 15 Series - Endurance titanesque"
              class="w-auto h-14 sm:h-24 md:h-32 lg:h-40 object-contain animate-text-title"
            />
          </div>

          <!-- Footer avec logos -->
          <div class="absolute bottom-2 left-2 right-2 sm:bottom-3 sm:left-3 sm:right-3 md:bottom-4 md:left-4 md:right-4 flex justify-between items-end">
            <!-- Logo HyperOS -->
            <div class="animate-footer-left -ml-1 sm:-ml-2 md:-ml-3 -mb-2 sm:-mb-3 md:-mb-4">
              <img
                v-if="hyperImage"
                :src="hyperImage"
                alt="Powered by Xiaomi HyperOS"
                class="h-12 sm:h-16 md:h-20 lg:h-24 w-auto"
              />
            </div>

            <!-- Texte DAS -->
            <div class="text-[6px] sm:text-[8px] md:text-[10px] text-gray-500 text-right max-w-[120px] sm:max-w-xs hidden sm:block animate-footer-right">
              <p>Image d'illustration. Le produit réel peut varier.</p>
              <p class="hidden md:block">DAS Redmi Note 15 Pro 5G : tête : 0.978 W/Kg, corps : 0.972 W/Kg, membres : 2.39 W/Kg.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section description (commentée)
    <div class="w-full py-6 px-4 sm:px-8" style="background-color: #E8E4DF;">
      <div class="mx-auto" style="max-width: 1240px;">
        <p class="text-gray-900 text-xs sm:text-sm lg:text-base leading-relaxed">
          <strong>La série REDMI Note 15 est conçue pour ceux qui exigent plus de leur smartphone, plus longtemps.</strong><br>
          Autonomie titanesque, résistance renforcée, longévité logicielle exceptionnelle et technologies d'intelligence artificielle de dernière génération : chaque détail a été pensé pour durer et vous accompagner au quotidien, année après année. Avec la série REDMI Note 15, la performance ne s'essouffle pas, la fiabilité ne faiblit pas et l'innovation est déjà entre vos mains.
        </p>
      </div>
    </div>
    -->

    <!-- Section cartes produits -->
    <div ref="sectionCards" class="w-full py-6 sm:py-8 md:py-10 px-3 sm:px-4 bg-white scroll-section" :class="{ 'animate-cards': visibleSections.cards }">
      <div class="mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4" style="max-width: 1240px;">

        <!-- Carte 1: REDMI Note 15 Pro+ -->
        <div class="card-item card-1 rounded-tl-2xl rounded-br-2xl p-3 sm:p-4 md:p-5 pb-0 flex flex-col relative overflow-hidden" style="background-color: #F5F3F0;">
          <div class="mb-3 sm:mb-4 h-5 sm:h-6">
            <img v-if="redImages.red1" :src="redImages.red1" alt="REDMI Note 15 Pro+ 5G" class="h-full w-auto" />
          </div>

          <div class="space-y-3 text-xs text-gray-700 flex-1">
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="6" y="4" width="12" height="17" rx="2" />
                <path d="M10 2h4" />
                <path d="M12 8v5" />
                <path d="M9 11h6" />
                <circle cx="12" cy="17" r="1.5" fill="currentColor" />
              </svg>
              <p>Xiaomi HyperCharge 100W<br>Batterie 6500mAh longue autonomie</p>
            </div>
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M12 2c-3 4-6 6.5-6 10a6 6 0 1 0 12 0c0-3.5-3-6-6-10z" />
                <path d="M12 18a2.5 2.5 0 0 1-2.5-2.5c0-1.5 2.5-4 2.5-4s2.5 2.5 2.5 4A2.5 2.5 0 0 1 12 18z" fill="currentColor" opacity="0.3" />
              </svg>
              <p>Résistance eau et poussière IP68<br>Verre renforcé Corning® Gorilla® Glass Victus® 2</p>
            </div>
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <circle cx="12" cy="12" r="9" />
                <circle cx="12" cy="12" r="5" />
                <circle cx="12" cy="12" r="2" fill="currentColor" />
                <path d="M12 3c2.5 2 4 5 4 9s-1.5 7-4 9" />
                <path d="M12 3c-2.5 2-4 5-4 9s1.5 7 4 9" />
              </svg>
              <p>Nouvel appareil photo 200 Mpx avec stabilisateur<br>Des photos et vidéos stables et détaillées même en x4</p>
            </div>
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="5" y="2" width="14" height="20" rx="2" />
                <path d="M9 5h6" />
                <circle cx="12" cy="18" r="1" fill="currentColor" />
              </svg>
              <p>Écran AMOLED 1.5K de 6.83''<br>Protections pour le confort des yeux</p>
            </div>
          </div>

          <div class="h-48 flex items-center justify-center mt-4 mb-0">
            <img
              v-if="pictureImages.picture1"
              :src="pictureImages.picture1"
              alt="REDMI Note 15 Pro+"
              class="h-full w-auto object-contain"
            />
          </div>

          <a href="https://www.mi.com/fr/product/redmi-note-15-pro-plus-5g/" target="_blank" class="absolute bottom-0 right-0 py-2 px-3 sm:py-3 sm:px-5 text-gray-800 font-bold text-[10px] sm:text-xs md:text-sm tracking-wide rounded-tl-2xl rounded-br-2xl z-10 transition-all duration-300 hover:bg-orange-500 hover:text-white hover:shadow-lg" style="background-color: #E8E4DF;">
            PLUS D'INFORMATIONS
          </a>
        </div>

        <!-- Carte 2: REDMI Note 15 Pro -->
        <div class="card-item card-2 rounded-tl-2xl rounded-br-2xl p-3 sm:p-4 md:p-5 pb-0 flex flex-col relative overflow-hidden" style="background-color: #F5F3F0;">
          <div class="mb-3 sm:mb-4 h-5 sm:h-6">
            <img v-if="redImages.red2" :src="redImages.red2" alt="REDMI Note 15 Pro 5G" class="h-full w-auto" />
          </div>

          <div class="space-y-3 text-xs text-gray-700 flex-1">
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="6" y="4" width="12" height="17" rx="2" />
                <path d="M10 2h4" />
                <path d="M12 8v5" />
                <path d="M9 11h6" />
                <circle cx="12" cy="17" r="1.5" fill="currentColor" />
              </svg>
              <p>Batterie 6580mAh longue autonomie<br>Charge rapide 45W</p>
            </div>
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M12 2c-3 4-6 6.5-6 10a6 6 0 1 0 12 0c0-3.5-3-6-6-10z" />
                <path d="M12 18a2.5 2.5 0 0 1-2.5-2.5c0-1.5 2.5-4 2.5-4s2.5 2.5 2.5 4A2.5 2.5 0 0 1 12 18z" fill="currentColor" opacity="0.3" />
              </svg>
              <p>Résistance eau et poussière IP68<br>Verre renforcé Corning® Gorilla® Glass Victus® 2</p>
            </div>
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <circle cx="12" cy="12" r="9" />
                <circle cx="12" cy="12" r="5" />
                <circle cx="12" cy="12" r="2" fill="currentColor" />
                <path d="M12 3c2.5 2 4 5 4 9s-1.5 7-4 9" />
                <path d="M12 3c-2.5 2-4 5-4 9s1.5 7 4 9" />
              </svg>
              <p>Nouvel appareil photo 200 Mpx avec stabilisateur<br>Des photos et vidéos stables et détaillées même en x4</p>
            </div>
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="5" y="2" width="14" height="20" rx="2" />
                <path d="M9 5h6" />
                <circle cx="12" cy="18" r="1" fill="currentColor" />
              </svg>
              <p>Écran AMOLED 1.5K de 6.83''<br>Protections pour le confort des yeux</p>
            </div>
          </div>

          <div class="h-48 flex items-center justify-center mt-4 mb-0">
            <img
              v-if="pictureImages.picture2"
              :src="pictureImages.picture2"
              alt="REDMI Note 15 Pro"
              class="h-full w-auto object-contain"
            />
          </div>

          <a href="https://www.mi.com/fr/product/redmi-note-15-pro-5g/" target="_blank" class="absolute bottom-0 right-0 py-2 px-3 sm:py-3 sm:px-5 text-gray-800 font-bold text-[10px] sm:text-xs md:text-sm tracking-wide rounded-tl-2xl rounded-br-2xl z-10 transition-all duration-300 hover:bg-orange-500 hover:text-white hover:shadow-lg" style="background-color: #E8E4DF;">
            PLUS D'INFORMATIONS
          </a>
        </div>

        <!-- Carte 3: REDMI Note 15 5G -->
        <div class="card-item card-3 rounded-tl-2xl rounded-br-2xl p-3 sm:p-4 md:p-5 pb-0 flex flex-col relative overflow-hidden" style="background-color: #F5F3F0;">
          <div class="mb-3 sm:mb-4 h-5 sm:h-6">
            <img v-if="redImages.red3" :src="redImages.red3" alt="REDMI Note 15 5G" class="h-full w-auto" />
          </div>

          <div class="space-y-3 text-xs text-gray-700 flex-1">
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="6" y="4" width="12" height="17" rx="2" />
                <path d="M10 2h4" />
                <path d="M12 8v5" />
                <path d="M9 11h6" />
                <circle cx="12" cy="17" r="1.5" fill="currentColor" />
              </svg>
              <p>Batterie 5520mAh longue autonomie<br>Design fin et charge rapide 45W</p>
            </div>
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M12 2c-3 4-6 6.5-6 10a6 6 0 1 0 12 0c0-3.5-3-6-6-10z" />
                <path d="M12 18a2.5 2.5 0 0 1-2.5-2.5c0-1.5 2.5-4 2.5-4s2.5 2.5 2.5 4A2.5 2.5 0 0 1 12 18z" fill="currentColor" opacity="0.3" />
              </svg>
              <p>Résistance eau et poussière IP65<br>Verre de protection renforcé</p>
            </div>
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <circle cx="12" cy="12" r="9" />
                <circle cx="12" cy="12" r="5" />
                <circle cx="12" cy="12" r="2" fill="currentColor" />
                <path d="M12 3c2.5 2 4 5 4 9s-1.5 7-4 9" />
                <path d="M12 3c-2.5 2-4 5-4 9s1.5 7 4 9" />
              </svg>
              <p>Appareil photo 108 Mpx avec stabilisateur<br>Des photos et vidéos stables et détaillées</p>
            </div>
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="5" y="2" width="14" height="20" rx="2" />
                <path d="M9 5h6" />
                <circle cx="12" cy="18" r="1" fill="currentColor" />
              </svg>
              <p>Écran AMOLED FHD+ de 6.77''<br>Protections pour le confort des yeux</p>
            </div>
          </div>

          <div class="h-48 flex items-center justify-center mt-4 mb-0">
            <img
              v-if="pictureImages.picture3"
              :src="pictureImages.picture3"
              alt="REDMI Note 15 5G"
              class="h-full w-auto object-contain"
            />
          </div>

          <a href="https://www.mi.com/fr/product/redmi-note-15-5g/" target="_blank" class="absolute bottom-0 right-0 py-2 px-3 sm:py-3 sm:px-5 text-gray-800 font-bold text-[10px] sm:text-xs md:text-sm tracking-wide rounded-tl-2xl rounded-br-2xl z-10 transition-all duration-300 hover:bg-orange-500 hover:text-white hover:shadow-lg" style="background-color: #E8E4DF;">
            PLUS D'INFORMATIONS
          </a>
        </div>

        <!-- Carte 4: REDMI Note 15 -->
        <div class="card-item card-4 rounded-tl-2xl rounded-br-2xl p-3 sm:p-4 md:p-5 pb-0 flex flex-col relative overflow-hidden" style="background-color: #F5F3F0;">
          <div class="mb-3 sm:mb-4 h-5 sm:h-6">
            <img v-if="redImages.red4" :src="redImages.red4" alt="REDMI Note 15" class="h-full w-auto" />
          </div>

          <div class="space-y-3 text-xs text-gray-700 flex-1">
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="6" y="4" width="12" height="17" rx="2" />
                <path d="M10 2h4" />
                <path d="M12 8v5" />
                <path d="M9 11h6" />
                <circle cx="12" cy="17" r="1.5" fill="currentColor" />
              </svg>
              <p>Batterie 6000mAh longue autonomie<br>Charge rapide 33W</p>
            </div>
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M12 2c-3 4-6 6.5-6 10a6 6 0 1 0 12 0c0-3.5-3-6-6-10z" />
                <path d="M12 18a2.5 2.5 0 0 1-2.5-2.5c0-1.5 2.5-4 2.5-4s2.5 2.5 2.5 4A2.5 2.5 0 0 1 12 18z" fill="currentColor" opacity="0.3" />
              </svg>
              <p>Résistance eau et poussière IP64<br>Verre de protection renforcé</p>
            </div>
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <circle cx="12" cy="12" r="9" />
                <circle cx="12" cy="12" r="5" />
                <circle cx="12" cy="12" r="2" fill="currentColor" />
                <path d="M12 3c2.5 2 4 5 4 9s-1.5 7-4 9" />
                <path d="M12 3c-2.5 2-4 5-4 9s1.5 7 4 9" />
              </svg>
              <p>Appareil photo 108 Mpx ultra-détaillé<br>Des photos et portraits détaillés</p>
            </div>
            <div class="flex items-start gap-2">
              <svg class="w-5 h-5 flex-shrink-0 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="5" y="2" width="14" height="20" rx="2" />
                <path d="M9 5h6" />
                <circle cx="12" cy="18" r="1" fill="currentColor" />
              </svg>
              <p>Écran AMOLED FHD+ de 6.77''<br>Protections pour le confort des yeux</p>
            </div>
          </div>

          <div class="h-48 flex items-center justify-center mt-4 mb-0">
            <img
              v-if="pictureImages.picture4"
              :src="pictureImages.picture4"
              alt="REDMI Note 15"
              class="h-full w-auto object-contain"
            />
          </div>

          <a href="https://www.mi.com/fr/product/redmi-note-15/" target="_blank" class="absolute bottom-0 right-0 py-2 px-3 sm:py-3 sm:px-5 text-gray-800 font-bold text-[10px] sm:text-xs md:text-sm tracking-wide rounded-tl-2xl rounded-br-2xl z-10 transition-all duration-300 hover:bg-orange-500 hover:text-white hover:shadow-lg" style="background-color: #E8E4DF;">
            PLUS D'INFORMATIONS
          </a>
        </div>

      </div>
    </div>

    <!-- Section Offre terminée -->
    <div class="w-full py-8 sm:py-10 md:py-12 px-3 sm:px-4" style="background-color: #F5F5F5;">
      <div class="max-w-4xl mx-auto">
        <div class="bg-white rounded-2xl p-6 sm:p-8 md:p-10 shadow-lg border-l-4 border-gray-400">
          <div class="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
            <!-- Icône -->
            <div class="flex-shrink-0">
              <div class="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gray-100 flex items-center justify-center">
                <svg class="w-8 h-8 sm:w-10 sm:h-10 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
            </div>
            
            <!-- Texte -->
            <div class="flex-1 text-center sm:text-left">
              <h2 class="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-2 sm:mb-3">
                L'offre de remboursement est terminée
              </h2>
              <p class="text-gray-600 text-sm sm:text-base leading-relaxed">
                L'offre de remboursement pour le lancement de la série REDMI Note 15 s'est terminée le <strong>15 mars 2026</strong>. Merci à tous les participants !
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section Détails de l'offre - DÉSACTIVÉE
    <div ref="sectionOffres" class="w-full py-8 sm:py-10 md:py-14" style="background-color: #F5F5F5;">
      <div class="max-w-5xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">

        <h2 class="text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-gray-900 mb-4 sm:mb-6 text-center uppercase tracking-wide">
          Offre de remboursement Xiaomi – Lancement REDMI Note 15 Series
        </h2>

        <div class="bg-white rounded-2xl p-4 sm:p-6 md:p-8 shadow-sm mb-6 sm:mb-8 border-l-4 border-orange-500">
          <p class="text-gray-700 text-sm sm:text-base leading-relaxed">
            <strong class="text-gray-900">Du 15 janvier au 15 mars 2026 inclus</strong>, obtenez jusqu'à <strong class="text-orange-500 text-lg sm:text-xl">50 €</strong> de remboursement pour l'achat d'un Smartphone de la gamme <strong>Xiaomi REDMI Note 15</strong> éligible dans une enseigne participante.
          </p>
        </div>

        <h3 class="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-6 sm:mb-8 text-center">
          Détails de la procédure
        </h3>

        <div class="space-y-4 sm:space-y-6">

          <div class="bg-white rounded-xl overflow-hidden shadow-sm">
            <div class="flex items-center gap-3 sm:gap-4 bg-gray-900 text-white px-4 sm:px-6 py-3 sm:py-4">
              <div class="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-orange-500 flex items-center justify-center font-bold text-sm sm:text-base flex-shrink-0">1</div>
              <h4 class="font-semibold text-sm sm:text-base md:text-lg">Achetez votre smartphone</h4>
            </div>
            <div class="p-4 sm:p-6">
              <p class="text-gray-700 text-sm sm:text-base leading-relaxed mb-4">
                Du <strong>15 janvier au 15 mars 2026</strong> inclus, achetez ou louez un smartphone Xiaomi parmi les modèles suivants dans l'une des enseignes participantes, en point de vente ou sur un site internet situé en France :
              </p>
              <ul class="space-y-2 mb-4">
                <li class="flex items-center gap-2 text-sm sm:text-base">
                  <span class="w-2 h-2 rounded-full bg-orange-500 flex-shrink-0"></span>
                  <span class="text-gray-700">REDMI Note 15</span>
                </li>
                <li class="flex items-center gap-2 text-sm sm:text-base">
                  <span class="w-2 h-2 rounded-full bg-orange-500 flex-shrink-0"></span>
                  <span class="text-gray-700">REDMI Note 15 5G</span>
                </li>
                <li class="flex items-center gap-2 text-sm sm:text-base">
                  <span class="w-2 h-2 rounded-full bg-orange-500 flex-shrink-0"></span>
                  <span class="text-gray-700">REDMI Note 15 Pro 5G</span>
                </li>
                <li class="flex items-center gap-2 text-sm sm:text-base">
                  <span class="w-2 h-2 rounded-full bg-orange-500 flex-shrink-0"></span>
                  <span class="text-gray-700">REDMI Note 15 Pro+ 5G</span>
                </li>
              </ul>

              <div class="bg-gray-50 rounded-lg p-4 sm:p-5">
                <p class="font-semibold text-gray-800 text-sm sm:text-base mb-3">Bénéficiez d'un remboursement allant jusqu'à :</p>
                <div class="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
                  <div class="text-center p-2 sm:p-3 bg-white rounded-lg border border-gray-200">
                    <p class="text-xl sm:text-2xl font-bold text-orange-500">20€</p>
                    <p class="text-[10px] sm:text-xs text-gray-600">REDMI Note 15</p>
                  </div>
                  <div class="text-center p-2 sm:p-3 bg-white rounded-lg border border-gray-200">
                    <p class="text-xl sm:text-2xl font-bold text-orange-500">30€</p>
                    <p class="text-[10px] sm:text-xs text-gray-600">REDMI Note 15 5G</p>
                  </div>
                  <div class="text-center p-2 sm:p-3 bg-white rounded-lg border border-gray-200">
                    <p class="text-xl sm:text-2xl font-bold text-orange-500">40€</p>
                    <p class="text-[10px] sm:text-xs text-gray-600">REDMI Note 15 Pro 5G</p>
                  </div>
                  <div class="text-center p-2 sm:p-3 bg-white rounded-lg border border-gray-200">
                    <p class="text-xl sm:text-2xl font-bold text-orange-500">50€</p>
                    <p class="text-[10px] sm:text-xs text-gray-600">REDMI Note 15 Pro+ 5G</p>
                  </div>
                </div>
                <p class="text-xs text-gray-500 mt-3 italic">
                  Offre réservée aux produits neufs. Le montant du remboursement ne pourra en aucun cas excéder le prix effectivement payé.
                </p>
              </div>
            </div>
          </div>

          <div class="bg-white rounded-xl overflow-hidden shadow-sm">
            <div class="flex items-center gap-3 sm:gap-4 bg-gray-900 text-white px-4 sm:px-6 py-3 sm:py-4">
              <div class="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-orange-500 flex items-center justify-center font-bold text-sm sm:text-base flex-shrink-0">2</div>
              <h4 class="font-semibold text-sm sm:text-base md:text-lg">Inscrivez-vous sur le site</h4>
            </div>
            <div class="p-4 sm:p-6">
              <p class="text-gray-700 text-sm sm:text-base leading-relaxed">
                Inscrivez-vous <strong>obligatoirement</strong> sur le site <strong class="text-orange-500">odr-xiaomi-rn15.fr</strong> entre le <strong>15 janvier 2026</strong> et le <strong>31 mars 2026</strong> inclus.
              </p>
            </div>
          </div>

          <div class="bg-white rounded-xl overflow-hidden shadow-sm">
            <div class="flex items-center gap-3 sm:gap-4 bg-gray-900 text-white px-4 sm:px-6 py-3 sm:py-4">
              <div class="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-orange-500 flex items-center justify-center font-bold text-sm sm:text-base flex-shrink-0">3</div>
              <h4 class="font-semibold text-sm sm:text-base md:text-lg">Renseignez le formulaire</h4>
            </div>
            <div class="p-4 sm:p-6">
              <p class="text-gray-700 text-sm sm:text-base leading-relaxed mb-4">
                Renseignez le formulaire d'inscription et téléchargez les pièces justificatives suivantes :
              </p>

              <div class="space-y-3">
                <div class="flex items-start gap-3 p-3 sm:p-4 bg-gray-50 rounded-lg">
                  <div class="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
                    <svg class="w-3 h-3 sm:w-4 sm:h-4 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                  </div>
                  <div>
                    <p class="font-semibold text-gray-800 text-sm sm:text-base">Preuve d'achat</p>
                    <p class="text-gray-600 text-xs sm:text-sm">Photo de votre facture ou ticket de caisse avec la date, le prix et la référence du produit entourés.</p>
                  </div>
                </div>

                <div class="flex items-start gap-3 p-3 sm:p-4 bg-gray-50 rounded-lg">
                  <div class="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
                    <svg class="w-3 h-3 sm:w-4 sm:h-4 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"/>
                    </svg>
                  </div>
                  <div>
                    <p class="font-semibold text-gray-800 text-sm sm:text-base">Code-barres découpé</p>
                    <p class="text-gray-600 text-xs sm:text-sm">Photo du code-barres <strong>découpé</strong> de l'emballage (code à 13 chiffres). Les photos du code-barres non découpé ne seront pas acceptées.</p>
                  </div>
                </div>

                <div class="flex items-start gap-3 p-3 sm:p-4 bg-gray-50 rounded-lg">
                  <div class="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
                    <svg class="w-3 h-3 sm:w-4 sm:h-4 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"/>
                    </svg>
                  </div>
                  <div>
                    <p class="font-semibold text-gray-800 text-sm sm:text-base">Code IMEI</p>
                    <p class="text-gray-600 text-xs sm:text-sm">Le code IMEI du smartphone (code à 15 chiffres), disponible sur l'étiquette ou dans les paramètres du téléphone.</p>
                  </div>
                </div>

                <div class="flex items-start gap-3 p-3 sm:p-4 bg-gray-50 rounded-lg">
                  <div class="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
                    <svg class="w-3 h-3 sm:w-4 sm:h-4 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
                    </svg>
                  </div>
                  <div>
                    <p class="font-semibold text-gray-800 text-sm sm:text-base">IBAN valide</p>
                    <p class="text-gray-600 text-xs sm:text-sm">Un IBAN rattaché à un compte domicilié en France métropolitaine (Corse incluse) ou DROM-COM.</p>
                  </div>
                </div>
              </div>

              <div class="mt-4 p-3 sm:p-4 bg-orange-50 border border-orange-200 rounded-lg">
                <p class="text-xs sm:text-sm text-gray-700">
                  <strong>Note :</strong> Si votre commande a été passée pendant la période de l'Opération mais que vous n'avez pas encore reçu votre téléphone ou votre facture, ajoutez votre confirmation de commande en complément.
                </p>
                <p class="text-xs sm:text-sm text-gray-700 mt-2">
                  <strong>Pour les professionnels :</strong> veuillez également fournir un justificatif d'immatriculation (inscription au RCS ou extrait Kbis de moins de trois mois).
                </p>
              </div>
            </div>
          </div>

          <div class="bg-white rounded-xl overflow-hidden shadow-sm">
            <div class="flex items-center gap-3 sm:gap-4 bg-gray-900 text-white px-4 sm:px-6 py-3 sm:py-4">
              <div class="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-orange-500 flex items-center justify-center font-bold text-sm sm:text-base flex-shrink-0">4</div>
              <h4 class="font-semibold text-sm sm:text-base md:text-lg">Recevez votre remboursement</h4>
            </div>
            <div class="p-4 sm:p-6">
              <p class="text-gray-700 text-sm sm:text-base leading-relaxed">
                Dans un délai de <strong>6 à 8 semaines</strong> après la validation de votre dossier (confirmée par e-mail), vous recevrez votre remboursement <strong>par virement bancaire</strong> sur le compte IBAN indiqué lors de votre inscription.
              </p>
              <div class="mt-4 flex items-center gap-3 p-3 sm:p-4 bg-green-50 border border-green-200 rounded-lg">
                <svg class="w-5 h-5 sm:w-6 sm:h-6 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <p class="text-green-700 text-sm sm:text-base font-medium">
                  Vous recevrez un email de confirmation à conserver.
                </p>
              </div>
            </div>
          </div>

        </div>

        <div class="mt-6 sm:mt-8 text-center">
          <router-link
            to="/form"
            class="inline-flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 sm:py-4 px-8 sm:px-12 rounded-full transition-all hover:shadow-lg text-sm sm:text-base md:text-lg"
          >
            <span>Je participe à l'offre</span>
            <svg class="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
            </svg>
          </router-link>
        </div>

      </div>
    </div>
    -->
    <div class="w-full py-6 px-4 sm:px-8" style="background-color: white">
      <div class="mx-auto" style="max-width: 1240px;">
        <p class="text-gray-900 text-xs sm:text-sm lg:text-base leading-relaxed">
          <strong>La série REDMI Note 15 est conçue pour ceux qui exigent plus de leur smartphone, plus longtemps.</strong><br>
          Autonomie titanesque, résistance renforcée, longévité logicielle exceptionnelle et technologies d'intelligence artificielle de dernière génération : chaque détail a été pensé pour durer et vous accompagner au quotidien, année après année. Avec la série REDMI Note 15, la performance ne s'essouffle pas, la fiabilité ne faiblit pas et l'innovation est déjà entre vos mains.
        </p>
      </div>
    </div>
    <!-- Section Autonomie -->
    <div ref="sectionAutonomie" class="w-full py-8 sm:py-10 md:py-12 px-3 sm:px-4 scroll-section" :class="{ 'animate-section-active': visibleSections.autonomie }" style="background: radial-gradient(ellipse at 30% 50%, #FFFFFF 0%, #EAEAEA 50%, #E0E0E0 100%);">
      <div class="mx-auto" style="max-width: 1240px;">



        
        <!-- Titre avec ligne -->
        <h2 class="section-title text-lg sm:text-xl md:text-2xl lg:text-3xl font-light text-gray-800 mb-2 sm:mb-3">Une autonomie à l'épreuve du temps</h2>
        <div class="section-line flex items-center mb-6 sm:mb-8 md:mb-10">
          <div class="w-8 sm:w-10 h-1" style="background-color: #FB023D;"></div>
          <div class="flex-1 h-px bg-gray-400"></div>
        </div>

        <!-- Contenu en 2 colonnes -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center">
          <!-- Gauche: Image -->
          <div class="section-image-left flex items-center justify-center">
            <img
              v-if="blocImages.bloc1"
              :src="blocImages.bloc1"
              alt="Autonomie REDMI Note 15"
              class="w-full h-auto rounded-lg object-cover"
            />
          </div>

          <!-- Droite: Description -->
          <div class="section-text flex items-center">
            <p class="text-gray-700 text-sm sm:text-base leading-relaxed">
              Pensée pour durer, la série REDMI Note 15 embarque une batterie à la durée de vie prolongée, capable de conserver sa capacité pendant plusieurs années. Associée à une gestion d'énergie intelligente et à une charge rapide toujours plus efficace, elle vous accompagne du matin au soir, jour après jour, sans compromis.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Section Résistance -->
    <div ref="sectionResistance" class="w-full py-8 sm:py-10 md:py-12 px-3 sm:px-4 bg-white scroll-section" :class="{ 'animate-section-active': visibleSections.resistance }">
      <div class="mx-auto" style="max-width: 1240px;">
        <!-- Titre avec ligne -->
        <h2 class="section-title text-lg sm:text-xl md:text-2xl lg:text-3xl font-light text-gray-800 mb-2 sm:mb-3">Une résistance à toute épreuve</h2>
        <div class="section-line flex items-center mb-6 sm:mb-8 md:mb-10">
          <div class="w-8 sm:w-10 h-1" style="background-color: #FB023D;"></div>
          <div class="flex-1 h-px bg-gray-400"></div>
        </div>

        <!-- Contenu en 2 colonnes -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center">
          <!-- Gauche: Description -->
          <div class="section-text flex items-center">
            <div class="text-gray-700 text-sm sm:text-base leading-relaxed">
              <p class="mb-4">
                La série REDMI Note 15 est conçue pour faire face aux aléas du quotidien.
              </p>
              <p class="mb-4">
                Grâce à une structure renforcée, des verres protecteurs résistants aux rayures, et une certification contre les éclaboussures et l'immersion, ces smartphones résistent aussi bien aux chocs qu'aux intempéries.
              </p>
              <p>
                Pluie, chutes accidentelles ou usage intensif : les REDMI Note 15 sont prêts à tout encaisser.
              </p>
            </div>
          </div>

          <!-- Droite: Image -->
          <div class="section-image-right flex items-center justify-center">
            <img
              v-if="blocImages.bloc2"
              :src="blocImages.bloc2"
              alt="Résistance REDMI Note 15"
              class="w-full h-auto rounded-lg object-cover"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Section Performances -->
    <div ref="sectionPerformances" class="w-full py-8 sm:py-10 md:py-12 px-3 sm:px-4 scroll-section" :class="{ 'animate-section-active': visibleSections.performances }" style="background: radial-gradient(ellipse at 30% 50%, #FFFFFF 0%, #EAEAEA 50%, #E0E0E0 100%);">
      <div class="mx-auto" style="max-width: 1240px;">
        <!-- Titre avec ligne -->
        <h2 class="section-title text-lg sm:text-xl md:text-2xl lg:text-3xl font-light text-gray-800 mb-2 sm:mb-3">Des performances fiables, aujourd'hui et demain</h2>
        <div class="section-line flex items-center mb-6 sm:mb-8 md:mb-10">
          <div class="w-8 sm:w-10 h-1" style="background-color: #FB023D;"></div>
          <div class="flex-1 h-px bg-gray-400"></div>
        </div>

        <!-- Contenu en 2 colonnes -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center">
          <!-- Gauche: Image -->
          <div class="section-image-left flex items-center justify-center">
            <img
              v-if="blocImages.bloc3"
              :src="blocImages.bloc3"
              alt="Performances REDMI Note 15"
              class="w-full h-auto rounded-lg object-cover"
            />
          </div>

          <!-- Droite: Description -->
          <div class="section-text flex items-center">
            <div class="text-gray-700 text-sm sm:text-base leading-relaxed">
              <p class="mb-4">
                Équipés de processeurs de dernière génération et propulsés par Xiaomi HyperOS, les smartphones de la série REDMI Note 15 offrent une interface ultra-fluide, stable et durable dans le temps.
              </p>
              <p>
                Avec 6 ans de mises à jour de sécurité, votre smartphone reste protégé, rapide et performant année après année, pour une expérience qui ne ralentit pas avec le temps.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section Photographie -->
    <div ref="sectionPhoto" class="w-full py-8 sm:py-10 md:py-12 px-3 sm:px-4 bg-white scroll-section" :class="{ 'animate-section-active': visibleSections.photo }">
      <div class="mx-auto" style="max-width: 1240px;">
        <!-- Titre avec ligne -->
        <h2 class="section-title text-lg sm:text-xl md:text-2xl lg:text-3xl font-light text-gray-800 mb-2 sm:mb-3">Une photographie de niveau professionnel</h2>
        <div class="section-line flex items-center mb-6 sm:mb-8 md:mb-10">
          <div class="w-8 sm:w-10 h-1" style="background-color: #FB023D;"></div>
          <div class="flex-1 h-px bg-gray-400"></div>
        </div>

        <!-- Contenu en 2 colonnes -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center">
          <!-- Gauche: Description -->
          <div class="section-text flex items-center">
            <div class="text-gray-700 text-sm sm:text-base leading-relaxed">
              <p class="mb-4">
                Grâce à des appareils photo IA de 108 ou 200 mégapixels, la série REDMI Note 15 capture chaque détail avec une précision exceptionnelle.
              </p>
              <p class="mb-4">
                Des photos ultra-nettes, même en conditions difficiles, et un zoom jusqu'à x4 sans perte permettent d'immortaliser chaque instant avec une qualité digne d'un appareil professionnel.
              </p>
              <p>
                Portraits, paysages ou photos du quotidien : chaque cliché est sublimé.
              </p>
            </div>
          </div>

          <!-- Droite: Image -->
          <div class="section-image-right flex items-center justify-center">
            <img
              v-if="blocImages.bloc4"
              :src="blocImages.bloc4"
              alt="Photographie REDMI Note 15"
              class="w-full h-auto rounded-lg object-cover"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Section Intelligence Artificielle -->
    <div ref="sectionIA" class="w-full py-8 sm:py-10 md:py-12 px-3 sm:px-4 scroll-section" :class="{ 'animate-section-active': visibleSections.ia }" style="background: radial-gradient(ellipse at 30% 50%, #FFFFFF 0%, #EAEAEA 50%, #E0E0E0 100%);">
      <div class="mx-auto" style="max-width: 1240px;">
        <!-- Titre avec ligne -->
        <h2 class="section-title text-lg sm:text-xl md:text-2xl lg:text-3xl font-light text-gray-800 mb-2 sm:mb-3">L'intelligence artificielle pour tous</h2>
        <div class="section-line flex items-center mb-6 sm:mb-8 md:mb-10">
          <div class="w-8 sm:w-10 h-1" style="background-color: #FB023D;"></div>
          <div class="flex-1 h-px bg-gray-400"></div>
        </div>

        <!-- Contenu en 2 colonnes -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center">
          <!-- Gauche: Image -->
          <div class="section-image-left flex items-center justify-center">
            <img
              v-if="blocImages.bloc5"
              :src="blocImages.bloc5"
              alt="Intelligence Artificielle REDMI Note 15"
              class="w-full h-auto rounded-lg object-cover"
            />
          </div>

          <!-- Droite: Description -->
          <div class="section-text flex items-center">
            <div class="text-gray-700 text-sm sm:text-base leading-relaxed">
              <p class="mb-4">
                La série REDMI Note 15 démocratise l'IA sur toute la gamme.
              </p>
              <p class="mb-4">
                Avec Google Gemini et Circle to Search, l'information et l'assistance intelligente sont toujours à portée de main.
              </p>
              <ul class="mb-4 space-y-2">
                <li class="flex items-start gap-2">
                  <span>–</span>
                  <span>Outils d'édition photo intelligents : disponibles sur tous les modèles.</span>
                </li>
                <li class="flex items-start gap-2">
                  <span>–</span>
                  <span>Fonctions d'édition avancées : disponibles sur les modèles "Pro"</span>
                </li>
                <li class="flex items-start gap-2">
                  <span>–</span>
                  <span>Fonctions de productivité puissantes qui vous simplifient la vie : disponible sur le REDMI Note 15 Pro+ 5G</span>
                </li>
              </ul>
              <p>
                Une IA pensée pour simplifier le quotidien, libérer la créativité et booster la productivité.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section Tableau Comparatif -->
    <div ref="sectionTable" class="w-full py-6 sm:py-8 md:py-12 px-2 sm:px-3 md:px-4 bg-white scroll-section overflow-hidden" :class="{ 'animate-table-reveal': visibleSections.table }">
      <div class="mx-auto overflow-hidden" style="max-width: 1240px;">

        <!-- Tableau comparatif -->
        <div class="overflow-x-auto overflow-y-hidden -mx-2 px-2">
          <table class="w-full min-w-[600px] sm:min-w-[700px] md:min-w-[800px]">
            <!-- En-tête avec noms des produits -->
            <thead>
              <tr>
                <th class="w-8 sm:w-10 md:w-12"></th>
                <th class="text-center pb-2 sm:pb-3 md:pb-4 px-1 sm:px-2">
                  <img v-if="redImages.red4" :src="redImages.red4" alt="REDMI Note 15" class="h-3 sm:h-4 md:h-5 w-auto mx-auto" />
                </th>
                <th class="text-center pb-2 sm:pb-3 md:pb-4 px-1 sm:px-2">
                  <img v-if="redImages.red3" :src="redImages.red3" alt="REDMI Note 15 5G" class="h-3 sm:h-4 md:h-5 w-auto mx-auto" />
                </th>
                <th class="text-center pb-2 sm:pb-3 md:pb-4 px-1 sm:px-2">
                  <img v-if="redImages.red2" :src="redImages.red2" alt="REDMI Note 15 Pro 5G" class="h-3 sm:h-4 md:h-5 w-auto mx-auto" />
                </th>
                <th class="text-center pb-2 sm:pb-3 md:pb-4 px-1 sm:px-2">
                  <img v-if="redImages.red1" :src="redImages.red1" alt="REDMI Note 15 Pro+ 5G" class="h-3 sm:h-4 md:h-5 w-auto mx-auto" />
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- Images des téléphones -->
              <tr>
                <td></td>
                <td class="text-center pt-2 sm:pt-3 md:pt-4 pb-0">
                  <img v-if="rdImages.rd1" :src="rdImages.rd1" alt="REDMI Note 15" class="h-16 sm:h-20 md:h-24 w-auto mx-auto object-contain" />
                </td>
                <td class="text-center pt-2 sm:pt-3 md:pt-4 pb-0">
                  <img v-if="rdImages.rd2" :src="rdImages.rd2" alt="REDMI Note 15 5G" class="h-16 sm:h-20 md:h-24 w-auto mx-auto object-contain" />
                </td>
                <td class="text-center pt-2 sm:pt-3 md:pt-4 pb-0">
                  <img v-if="rdImages.rd3" :src="rdImages.rd3" alt="REDMI Note 15 Pro 5G" class="h-16 sm:h-20 md:h-24 w-auto mx-auto object-contain" />
                </td>
                <td class="text-center pt-2 sm:pt-3 md:pt-4 pb-0">
                  <img v-if="rdImages.rd4" :src="rdImages.rd4" alt="REDMI Note 15 Pro+ 5G" class="h-16 sm:h-20 md:h-24 w-auto mx-auto object-contain" />
                </td>
              </tr>

              <!-- 6 ans mises à jour -->
              <tr>
                <td class="pt-0 pb-1 sm:pb-2">
                  <svg class="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  </svg>
                </td>
                <td colspan="4" class="pt-0 pb-1 sm:pb-2">
                  <div class="rounded-full py-2 sm:py-3 px-3 sm:px-6 text-center" style="background-color: #E8E4DF;">
                    <span class="text-lg sm:text-xl md:text-2xl font-bold text-gray-800">6 ans</span>
                    <span class="text-gray-600 ml-1 sm:ml-2 text-[10px] sm:text-xs md:text-sm">mises à jour de sécurité ¹</span>
                  </div>
                </td>
              </tr>

              <!-- Xiaomi HyperOS -->
              <tr>
                <td class="py-1 sm:py-2">
                  <svg class="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <rect x="5" y="2" width="14" height="20" rx="2"/>
                    <path d="M12 18h.01"/>
                  </svg>
                </td>
                <td colspan="4" class="py-1 sm:py-2">
                  <div class="rounded-full py-2 sm:py-3 px-3 sm:px-6 text-center" style="background-color: #E8E4DF;">
                    <span class="text-gray-700 text-[10px] sm:text-xs md:text-sm">Xiaomi HyperOS : interface optimisée qui reste fluide dans le temps</span>
                  </div>
                </td>
              </tr>

              <!-- 200/300 chutes -->
              <tr>
                <td class="py-1 sm:py-2">
                  <svg class="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M12 8v4l2 2"/>
                  </svg>
                </td>
                <td colspan="2" class="py-1 sm:py-2 pr-1">
                  <div class="rounded-full py-2 sm:py-3 px-2 sm:px-4 text-center" style="background-color: #E8E4DF;">
                    <span class="text-gray-700 text-[10px] sm:text-xs md:text-sm">200 chutes sans dégâts</span>
                  </div>
                </td>
                <td colspan="2" class="py-1 sm:py-2 pl-1">
                  <div class="rounded-full py-2 sm:py-3 px-2 sm:px-4 text-center text-white flex items-center justify-center gap-1 sm:gap-2" style="background-color: #4A4A4A;">
                    <span class="bg-white text-gray-800 rounded-full w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 flex items-center justify-center text-sm sm:text-base md:text-lg font-bold">+</span>
                    <span class="text-[10px] sm:text-xs md:text-sm"><span class="text-sm sm:text-lg md:text-xl font-bold">300</span> chutes sans dégâts ²</span>
                  </div>
                </td>
              </tr>

              <!-- Résiste aux rayures -->
              <tr>
                <td class="py-1 sm:py-2">
                  <svg class="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M4 4l16 16M4 20L20 4"/>
                  </svg>
                </td>
                <td colspan="2" class="py-1 sm:py-2 pr-1">
                  <div class="rounded-full py-2 sm:py-3 px-2 sm:px-4 text-center" style="background-color: #E8E4DF;">
                    <span class="text-gray-700 text-[10px] sm:text-xs md:text-sm">Résiste aux rayures</span>
                  </div>
                </td>
                <td colspan="2" class="py-1 sm:py-2 pl-1">
                  <div class="rounded-full py-2 sm:py-3 px-2 sm:px-4 text-center text-white flex items-center justify-center gap-1 sm:gap-2" style="background-color: #4A4A4A;">
                    <span class="bg-white text-gray-800 rounded-full w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 flex items-center justify-center text-sm sm:text-base md:text-lg font-bold">+</span>
                    <span class="text-[10px] sm:text-xs md:text-sm"><span class="text-sm sm:text-lg md:text-xl font-bold">2x</span> plus résistant ³</span>
                  </div>
                </td>
              </tr>

              <!-- Résiste aux éclaboussures -->
              <tr>
                <td class="py-1 sm:py-2">
                  <svg class="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M12 2c-3 4-6 6.5-6 10a6 6 0 1 0 12 0c0-3.5-3-6-6-10z"/>
                  </svg>
                </td>
                <td colspan="2" class="py-1 sm:py-2 pr-1">
                  <div class="rounded-full py-2 sm:py-3 px-2 sm:px-4 text-center" style="background-color: #E8E4DF;">
                    <span class="text-gray-700 text-[10px] sm:text-xs md:text-sm">Résiste aux éclaboussures</span>
                  </div>
                </td>
                <td colspan="2" class="py-1 sm:py-2 pl-1">
                  <div class="rounded-full py-2 sm:py-3 px-2 sm:px-4 text-center text-white flex items-center justify-center gap-1 sm:gap-2" style="background-color: #4A4A4A;">
                    <span class="bg-white text-gray-800 rounded-full w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 flex items-center justify-center text-sm sm:text-base md:text-lg font-bold">+</span>
                    <span class="text-[10px] sm:text-xs md:text-sm"><span class="text-sm sm:text-lg md:text-xl font-bold">24h</span> en immersion ⁴</span>
                  </div>
                </td>
              </tr>

              <!-- 48h/60h autonomie -->
              <tr>
                <td class="py-1 sm:py-2">
                  <svg class="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <rect x="6" y="4" width="12" height="17" rx="2"/>
                    <path d="M10 2h4"/>
                  </svg>
                </td>
                <td colspan="2" class="py-1 sm:py-2 pr-1">
                  <div class="rounded-full py-2 sm:py-3 px-2 sm:px-4 text-center" style="background-color: #E8E4DF;">
                    <span class="text-gray-700 text-[10px] sm:text-xs md:text-sm">48h d'autonomie</span>
                  </div>
                </td>
                <td colspan="2" class="py-1 sm:py-2 pl-1">
                  <div class="rounded-full py-2 sm:py-3 px-2 sm:px-4 text-center text-white flex items-center justify-center gap-1 sm:gap-2" style="background-color: #4A4A4A;">
                    <span class="bg-white text-gray-800 rounded-full w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 flex items-center justify-center text-sm sm:text-base md:text-lg font-bold">+</span>
                    <span class="text-[10px] sm:text-xs md:text-sm"><span class="text-sm sm:text-lg md:text-xl font-bold">60h</span> d'autonomie ⁵</span>
                  </div>
                </td>
              </tr>

              <!-- 5 ans/6 ans autonomie préservée -->
              <tr>
                <td class="py-1 sm:py-2">
                  <svg class="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <rect x="2" y="7" width="20" height="14" rx="2"/>
                    <path d="M16 7V5a4 4 0 0 0-8 0v2"/>
                  </svg>
                </td>
                <td colspan="2" class="py-1 sm:py-2 pr-1">
                  <div class="rounded-full py-2 sm:py-3 px-2 sm:px-4 text-center" style="background-color: #E8E4DF;">
                    <span class="text-gray-700 text-[10px] sm:text-xs md:text-sm">5 ans d'autonomie préservée</span>
                  </div>
                </td>
                <td colspan="2" class="py-1 sm:py-2 pl-1">
                  <div class="rounded-full py-2 sm:py-3 px-2 sm:px-4 text-center text-white flex items-center justify-center gap-1 sm:gap-2" style="background-color: #4A4A4A;">
                    <span class="bg-white text-gray-800 rounded-full w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 flex items-center justify-center text-sm sm:text-base md:text-lg font-bold">+</span>
                    <span class="text-[10px] sm:text-xs md:text-sm"><span class="text-sm sm:text-lg md:text-xl font-bold">6 ans</span> d'autonomie préservée ⁶</span>
                  </div>
                </td>
              </tr>

              <!-- 108 Mpx / 200 Mpx -->
              <tr>
                <td class="py-1 sm:py-2">
                  <svg class="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <circle cx="12" cy="12" r="3"/>
                    <circle cx="12" cy="12" r="9"/>
                  </svg>
                </td>
                <td class="py-1 sm:py-2 pr-1">
                  <div class="rounded-full py-2 sm:py-3 px-1 sm:px-2 text-center" style="background-color: #E8E4DF;">
                    <span class="text-gray-700 text-[10px] sm:text-xs md:text-sm">108 Mpx</span>
                  </div>
                </td>
                <td class="py-1 sm:py-2 px-1">
                  <div class="rounded-full py-2 sm:py-3 px-1 sm:px-2 text-center" style="background-color: #E8E4DF;">
                    <span class="text-gray-700 text-[10px] sm:text-xs md:text-sm">108 Mpx avec stabilisateur</span>
                  </div>
                </td>
                <td colspan="2" class="py-1 sm:py-2 pl-1">
                  <div class="rounded-full py-2 sm:py-3 px-2 sm:px-4 text-center text-white flex items-center justify-center gap-1 sm:gap-2" style="background-color: #4A4A4A;">
                    <span class="bg-white text-gray-800 rounded-full w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 flex items-center justify-center text-sm sm:text-base md:text-lg font-bold">+</span>
                    <span class="text-[10px] sm:text-xs md:text-sm"><span class="text-sm sm:text-lg md:text-xl font-bold">200 Mpx</span> avec stabilisateur</span>
                  </div>
                </td>
              </tr>

              <!-- 30min/40min charge -->
              <tr>
                <td class="py-1 sm:py-2">
                  <svg class="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                  </svg>
                </td>
                <td colspan="2" class="py-1 sm:py-2 pr-1">
                  <div class="rounded-full py-2 sm:py-3 px-2 sm:px-4 text-center" style="background-color: #E8E4DF;">
                    <span class="text-gray-700 text-[10px] sm:text-xs md:text-sm">30min pour 50%</span>
                  </div>
                </td>
                <td colspan="2" class="py-1 sm:py-2 pl-1">
                  <div class="rounded-full py-2 sm:py-3 px-2 sm:px-4 text-center text-white flex items-center justify-center gap-1 sm:gap-2" style="background-color: #4A4A4A;">
                    <span class="bg-white text-gray-800 rounded-full w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 flex items-center justify-center text-sm sm:text-base md:text-lg font-bold">+</span>
                    <span class="text-[10px] sm:text-xs md:text-sm"><span class="text-sm sm:text-lg md:text-xl font-bold">40min</span> pour 100% ⁷</span>
                  </div>
                </td>
              </tr>

              <!-- AI / Google Gemini -->
              <tr>
                <td class="py-1 sm:py-2">
                  <span class="text-sm sm:text-lg md:text-xl font-bold" style="color: #6366F1;">AI</span>
                  <span class="text-[10px] sm:text-xs md:text-sm" style="color: #F59E0B;">✦</span>
                </td>
                <td colspan="4" class="py-1 sm:py-2">
                  <div class="rounded-full py-2 sm:py-3 px-3 sm:px-6 text-center text-white" style="background: linear-gradient(90deg, #6366F1 0%, #8B5CF6 50%, #EC4899 100%);">
                    <span class="flex items-center justify-center gap-1 sm:gap-2">
                      <span class="text-[10px] sm:text-xs md:text-sm" style="color: #60A5FA;">✦</span>
                      <span class="font-medium text-[10px] sm:text-xs md:text-sm">Google Gemini</span>
                    </span>
                  </div>
                </td>
              </tr>

            </tbody>
          </table>
        </div>

        <!-- Mentions légales du tableau -->
        <div class="mt-4 sm:mt-6 text-[8px] sm:text-[9px] md:text-[10px] text-gray-500 leading-relaxed">
          <p>[1] Conformément à la réglementation en vigueur. [2] Résiste sans dégâts à 200/300 chutes lors de tests de chute en balancier. Données issues des laboratoires internes de Xiaomi, les données réelles peuvent varier. [3] Le verre de protection Corning® Gorilla® Glass Victus® 2 qui équipe les REDMI Note 15 Pro 5G et Pro+ 5G résiste à une chute de 2m sur surface de grain 180, soit 2 fois plus haut que le verre Corning® Gorilla® Glass 7i qui équipe les REDMI Note 15 et 15 5G. [4] Les REDMI Note 15 et 15 5G sont respectivement certifiés IP64 et IP65. Les REDMI Note 15 Pro 5G et 15 Pro+ 5G sont certifiés IP68. Les tests incluent une immersion dans de l'eau douce statique jusqu'à 2m de profondeur pendant 24h, à une température de l'eau ne dépassant pas 15 °C par rapport à celle de l'appareil. Cette résistance est obtenue dans des conditions de laboratoire et peut se dégrader avec l'usure ou les dommages. La garantie ne couvre pas les dégâts liés aux liquides en dehors de ces conditions de test. [5] Données issues des laboratoires internes de Xiaomi, les données réelles peuvent varier. [6] Jusqu'à 80 % de capacité conservée après 1 000 cycles de charge/décharge. 1 cycle = 2 jours (REDMI Note 15/15 5G) ; 2,5 jours (REDMI Note 15 Pro 5G/Pro+ 5G). [7] Charge complète de 0 à 100 % en 40 minutes avec un chargeur 100W en mode vitesse maximum, à une température ambiante de 25 °C. Données issues des laboratoires internes de Xiaomi, les résultats réels peuvent varier. Chargeurs vendus séparément. Google et Gemini sont des marques de Google LLC.</p>
        </div>

      </div>
    </div>

  </main>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      phoneImage: null,
      bannerImage: null,
      logoImage: null,
      bigTitleImage: null,
      hyperImage: null,
      blocImages: {
        bloc1: null,
        bloc2: null,
        bloc3: null,
        bloc4: null,
        bloc5: null,
      },
      pictureImages: {
        picture1: null,
        picture2: null,
        picture3: null,
        picture4: null,
      },
      redImages: {
        red1: null,
        red2: null,
        red3: null,
        red4: null,
      },
      rdImages: {
        rd1: null,
        rd2: null,
        rd3: null,
        rd4: null,
      },
      visibleSections: {
        cards: false,
        autonomie: false,
        resistance: false,
        performances: false,
        photo: false,
        ia: false,
        table: false,
      },
      showFloatingButton: true,
      scrollPosition: 0,
    };
  },
  created() {
    // Charger et précharger les images principales
    const mainImages = [
      { key: 'phoneImage', file: 'xiaomi-15-ultra.png' },
      { key: 'bannerImage', file: 'home.png' },
      { key: 'logoImage', file: 'logo.png' },
      { key: 'bigTitleImage', file: 'bigtitle2.png' },
      { key: 'hyperImage', file: 'hyper.png' },
    ];
    mainImages.forEach(({ key, file }) => {
      try {
        const imageSrc = require(`@/assets/images/${file}`);
        this[key] = imageSrc;
        // Préchargement en mémoire du navigateur
        const img = new Image();
        img.src = imageSrc;
      } catch (e) {
        this[key] = null;
      }
    });
    // Préchargement des autres images
    this.preloadBlocImages();
  },
  mounted() {
    this.setupScrollAnimations();
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrollPosition = window.scrollY;
      // Cacher le bouton quand on approche de la section offres
      const offresSection = this.$refs.sectionOffres;
      if (offresSection) {
        const rect = offresSection.getBoundingClientRect();
        // Cacher si la section offres est visible dans le viewport
        this.showFloatingButton = rect.top > window.innerHeight * 0.5;
      }
    },
    scrollToOffres() {
      const offresSection = this.$refs.sectionOffres;
      if (offresSection) {
        const yOffset = -30; // 30px au-dessus de la section
        const y = offresSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    },
    preloadBlocImages() {
      // Charger et mettre en cache les images des blocs
      const blocNames = ['bloc1', 'bloc2', 'bloc3', 'bloc4', 'bloc5'];
      blocNames.forEach((name) => {
        try {
          const imageSrc = require(`@/assets/images/${name}.png`);
          this.blocImages[name] = imageSrc;
          // Préchargement en mémoire du navigateur
          const img = new Image();
          img.src = imageSrc;
        } catch (e) {
          this.blocImages[name] = null;
        }
      });
      // Charger et mettre en cache les images des téléphones (Picture)
      const pictureNames = ['Picture1', 'Picture2', 'Picture3', 'Picture4'];
      pictureNames.forEach((name, index) => {
        try {
          const imageSrc = require(`@/assets/images/${name}.png`);
          this.pictureImages[`picture${index + 1}`] = imageSrc;
          // Préchargement en mémoire du navigateur
          const img = new Image();
          img.src = imageSrc;
        } catch (e) {
          this.pictureImages[`picture${index + 1}`] = null;
        }
      });
      // Charger et mettre en cache les images des titres (red)
      const redNames = ['red1', 'red2', 'red3', 'red4'];
      redNames.forEach((name) => {
        try {
          const imageSrc = require(`@/assets/images/${name}.png`);
          this.redImages[name] = imageSrc;
          // Préchargement en mémoire du navigateur
          const img = new Image();
          img.src = imageSrc;
        } catch (e) {
          this.redImages[name] = null;
        }
      });
      // Charger et mettre en cache les images des téléphones du tableau (rd)
      const rdNames = ['rd1', 'rd2', 'rd3', 'rd4'];
      rdNames.forEach((name) => {
        try {
          const imageSrc = require(`@/assets/images/${name}.png`);
          this.rdImages[name] = imageSrc;
          // Préchargement en mémoire du navigateur
          const img = new Image();
          img.src = imageSrc;
        } catch (e) {
          this.rdImages[name] = null;
        }
      });
    },
    setupScrollAnimations() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.15,
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const sectionName = entry.target.dataset.section;
          if (sectionName) {
            if (entry.isIntersecting) {
              this.visibleSections[sectionName] = true;
            } else {
              // Réinitialiser l'animation quand la section sort du viewport
              this.visibleSections[sectionName] = false;
            }
          }
        });
      }, options);

      // Sections observées immédiatement (plus bas dans la page)
      const immediateSections = [
        { ref: 'sectionResistance', name: 'resistance' },
        { ref: 'sectionPerformances', name: 'performances' },
        { ref: 'sectionPhoto', name: 'photo' },
        { ref: 'sectionIA', name: 'ia' },
        { ref: 'sectionTable', name: 'table' },
      ];

      immediateSections.forEach(({ ref, name }) => {
        const element = this.$refs[ref];
        if (element) {
          element.dataset.section = name;
          this.observer.observe(element);
        }
      });

      // Sections proches du haut - observer avec délai pour voir l'animation
      const delayedSections = [
        { ref: 'sectionCards', name: 'cards', delay: 300 },
        { ref: 'sectionAutonomie', name: 'autonomie', delay: 500 },
      ];

      delayedSections.forEach(({ ref, name, delay }) => {
        setTimeout(() => {
          const element = this.$refs[ref];
          if (element) {
            element.dataset.section = name;
            this.observer.observe(element);
          }
        }, delay);
      });
    },
  },
};
</script>

<style scoped>
/* ===== BANNER ANIMATIONS ===== */

/* Image de fond - zoom fluide avec fade */
.animate-banner-image {
  animation: bannerImageReveal 1.6s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

@keyframes bannerImageReveal {
  0% {
    opacity: 0;
    transform: scale(1.12) translateY(40px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Logo Mi - apparition avec rotation et scale */
.animate-logo-mi {
  animation: logoMiReveal 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.4s forwards;
  opacity: 0;
}

@keyframes logoMiReveal {
  0% {
    opacity: 0;
    transform: scale(0) rotate(-180deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
}

/* Texte "Xiaomi présente" - slide down avec fade */
.animate-text-présente {
  animation: textSlideDown 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s forwards;
  opacity: 0;
}

@keyframes textSlideDown {
  0% {
    opacity: 0;
    transform: translateY(-30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Titre principal - effet de révélation avec scale */
.animate-text-title {
  animation: titleReveal 0.9s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s forwards;
  opacity: 0;
}

@keyframes titleReveal {
  0% {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
    letter-spacing: 0.3em;
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    letter-spacing: normal;
  }
}

/* Sous-titre - slide up élégant */
.animate-text-subtitle {
  animation: subtitleReveal 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.8s forwards;
  opacity: 0;
}

@keyframes subtitleReveal {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Footer gauche - slide depuis la gauche */
.animate-footer-left {
  animation: footerLeftReveal 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 1s forwards;
  opacity: 0;
}

@keyframes footerLeftReveal {
  0% {
    opacity: 0;
    transform: translateX(-30px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Footer droite - slide depuis la droite */
.animate-footer-right {
  animation: footerRightReveal 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 1s forwards;
  opacity: 0;
}

@keyframes footerRightReveal {
  0% {
    opacity: 0;
    transform: translateX(30px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

/* ===== SCROLL ANIMATIONS ===== */

/* État initial invisible pour toutes les sections */
.scroll-section {
  opacity: 0;
}

/* Animation 1: Cards - apparition en cascade depuis le bas */
.animate-cards {
  opacity: 1;
}

.animate-cards .card-item {
  opacity: 0;
  transform: translateY(60px);
  animation: cardReveal 1.2s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.animate-cards .card-1 { animation-delay: 0s; }
.animate-cards .card-2 { animation-delay: 0.2s; }
.animate-cards .card-3 { animation-delay: 0.4s; }
.animate-cards .card-4 { animation-delay: 0.6s; }

@keyframes cardReveal {
  0% {
    opacity: 0;
    transform: translateY(60px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Animation des sections avec image/texte séparés */
.animate-section-active {
  opacity: 1;
}

/* État initial des éléments de section */
.scroll-section .section-title,
.scroll-section .section-line,
.scroll-section .section-image-left,
.scroll-section .section-image-right,
.scroll-section .section-text {
  opacity: 0;
}

/* Titre - fade down */
.animate-section-active .section-title {
  animation: sectionTitleReveal 1.2s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

@keyframes sectionTitleReveal {
  0% {
    opacity: 0;
    transform: translateY(-25px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Ligne - expand */
.animate-section-active .section-line {
  animation: sectionLineReveal 1.4s cubic-bezier(0.22, 1, 0.36, 1) 0.2s forwards;
}

@keyframes sectionLineReveal {
  0% {
    opacity: 0;
    transform: scaleX(0);
    transform-origin: left;
  }
  100% {
    opacity: 1;
    transform: scaleX(1);
  }
}

/* Image depuis la gauche */
.animate-section-active .section-image-left {
  animation: imageFromLeft 1.4s cubic-bezier(0.22, 1, 0.36, 1) 0.3s forwards;
}

@keyframes imageFromLeft {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Image depuis la droite */
.animate-section-active .section-image-right {
  animation: imageFromRight 1.4s cubic-bezier(0.22, 1, 0.36, 1) 0.3s forwards;
}

@keyframes imageFromRight {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Texte - fade up avec délai */
.animate-section-active .section-text {
  animation: sectionTextReveal 1.3s cubic-bezier(0.22, 1, 0.36, 1) 0.5s forwards;
}

@keyframes sectionTextReveal {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Animation 7: Révélation du tableau ligne par ligne */
.animate-table-reveal {
  animation: tableReveal 1s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.animate-table-reveal table tbody tr {
  opacity: 0;
  animation: tableRowReveal 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
  will-change: opacity;
}

.animate-table-reveal table tbody tr:nth-child(1) { animation-delay: 0.1s; }
.animate-table-reveal table tbody tr:nth-child(2) { animation-delay: 0.18s; }
.animate-table-reveal table tbody tr:nth-child(3) { animation-delay: 0.26s; }
.animate-table-reveal table tbody tr:nth-child(4) { animation-delay: 0.34s; }
.animate-table-reveal table tbody tr:nth-child(5) { animation-delay: 0.42s; }
.animate-table-reveal table tbody tr:nth-child(6) { animation-delay: 0.50s; }
.animate-table-reveal table tbody tr:nth-child(7) { animation-delay: 0.58s; }
.animate-table-reveal table tbody tr:nth-child(8) { animation-delay: 0.66s; }
.animate-table-reveal table tbody tr:nth-child(9) { animation-delay: 0.74s; }
.animate-table-reveal table tbody tr:nth-child(10) { animation-delay: 0.82s; }
.animate-table-reveal table tbody tr:nth-child(11) { animation-delay: 0.90s; }

@keyframes tableReveal {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes tableRowReveal {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* ===== EXISTING ANIMATIONS ===== */

.fade-in {
  animation: fadeIn 1.5s ease-in-out;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.phone-halo {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(60, 60, 60, 0.4) 0%, rgba(80, 80, 80, 0.2) 40%, transparent 70%);
  border-radius: 50%;
  filter: blur(30px);
  animation: haloGlow 3s ease-in-out infinite alternate;
}

@keyframes haloGlow {
  0% {
    opacity: 0.6;
    transform: scale(1);
  }
  100% {
    opacity: 1;
    transform: scale(1.1);
  }
}

@media (min-width: 640px) {
  .phone-halo {
    width: 400px;
    height: 400px;
  }
}

@media (min-width: 1024px) {
  .phone-halo {
    width: 500px;
    height: 500px;
  }
}

/* ===== FLOATING BUTTON ANIMATIONS ===== */

.floating-cta {
  box-shadow: 0 4px 15px rgba(251, 2, 61, 0.25);
}

.floating-cta:hover {
  box-shadow: 0 6px 20px rgba(251, 2, 61, 0.35);
}

@keyframes bounce-subtle {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(3px);
  }
}

.animate-bounce-subtle {
  animation: bounce-subtle 1.5s ease-in-out infinite;
}

/* Transition pour le bouton flottant */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(20px) scale(0.9);
}

</style>
